import { errorTranslations } from "schema"

export default {
  errors: errorTranslations["en-US"],
}
